<template>
  <div>
    <div class="row-box">
      <WrapperField
        v-for="(fieldValue, fieldName) in orderedData"
        :key="fieldValue + fieldName + Math.random()"
        :data="
          createDataField({
            fieldName,
            fieldValue,
            fieldGroup: FieldGroup.MRPA_ASSISTANT,
          })
        "
      />
    </div>
  </div>
</template>

<script>
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import { FieldName } from '@/constants';

const order = [
  'assistantJob',
  'assistantRegNumber',
  'assistantFirstName',
  'assistantLastName',
  'assistantPatronymic',
];

export default {
  name: 'MrpaAssistant',
  props: ['data'],
  components: {
    WrapperField,
  },
  data: () => ({
    FieldGroup,
    FieldName,
    createDataField,
  }),
  computed: {
    orderedData() {
      const res = {};

      order.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.data, key)) {
          res[key] = this.data[key];
        }
      });

      return res;
    },
  },
};
</script>
